import { Star } from "lucide-react";
import { Reveal, SectionHeading } from "./shared";

const QUOTES = [
    {
        text: "“Professional, welcoming and accommodating from the moment we walked in.”",
        label: "Google review theme",
    },
    {
        text: "“They made us feel completely relaxed in front of the camera.”",
        label: "Google review theme",
    },
    {
        text: "“A comfortable, well-prepared studio, everything was ready when we arrived.”",
        label: "Google review theme",
    },
];

export default function Reviews() {
    return (
        <section id="reviews" className="relative py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="grid items-start gap-12 lg:grid-cols-12">
                    <div className="lg:col-span-4">
                        <Reveal>
                            <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-gold">
                                Wall of Love
                            </p>
                        </Reveal>
                        <Reveal delay={0.08}>
                            <div className="mt-6 flex items-end gap-4" data-testid="reviews-score">
                                <span className="font-serif text-7xl font-bold leading-none text-goldgrad sm:text-8xl">
                                    5.0
                                </span>
                                <span className="pb-2">
                                    {[...Array(5)].map((_, i) => (
                                        <Star key={i} className="inline h-5 w-5 fill-gold text-gold" />
                                    ))}
                                    <span className="mt-1 block text-sm text-mist">23 Google reviews</span>
                                </span>
                            </div>
                        </Reveal>
                        <Reveal delay={0.16}>
                            <p className="mt-6 text-base leading-relaxed text-mist">
                                WVE Studios, the team behind Essex Photography Studio, have been
                                photographing families since 2015. These are the words their
                                reviewers use most.
                            </p>
                        </Reveal>
                    </div>
                    <div className="grid gap-5 lg:col-span-8 sm:grid-cols-2" data-testid="reviews-cards">
                        {QUOTES.map((q, i) => (
                            <Reveal key={q.text} delay={0.1 + i * 0.08} className={i === 2 ? "sm:col-span-2" : ""}>
                                <figure className="glass-card h-full rounded-3xl p-7">
                                    <div className="flex gap-1">
                                        {[...Array(5)].map((_, s) => (
                                            <Star key={s} className="h-3.5 w-3.5 fill-gold text-gold" />
                                        ))}
                                    </div>
                                    <blockquote className="mt-4 font-serif text-lg italic leading-snug text-cream sm:text-xl">
                                        {q.text}
                                    </blockquote>
                                    <figcaption className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-gold/80">
                                        {q.label}
                                    </figcaption>
                                </figure>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
